import React, { useCallback } from 'react'

import { CaretLeft, CaretRight } from '@phosphor-icons/react'
import { useSwiper } from 'swiper/react'

import { StyledButton } from './styles'

type Props = {
  isNext?: boolean
}

function LearnSectionGalleryCarouselButton({ isNext }: Props) {
  const swiper = useSwiper()

  const handleClick = useCallback(() => {
    if (isNext) {
      swiper.slideNext()
      return
    }

    swiper.slidePrev()
  }, [swiper, isNext])

  return (
    <StyledButton right={isNext} onClick={handleClick}>
      {isNext ? (
        <CaretRight size={30} weight="bold" />
      ) : (
        <CaretLeft size={30} weight="bold" />
      )}
    </StyledButton>
  )
}

export default LearnSectionGalleryCarouselButton
